export const SHIMONOSEKI_PORT_LATLNG = {lat: 33.94710611311552, lng: 130.93535245975596};